var $ = jQuery;

const searchInput = document.querySelector('#filter_articles_search');

if (searchInput) {    

    addEventListeners()
}

function addEventListeners() {
    const searchBtn = searchInput.querySelector('input[type="submit"]');
    const catSelect = document.querySelector('#article-cat');

    // Click on search
    searchBtn.addEventListener('click', function(e) {
        e.preventDefault()        

        getArticles();
        
    });

    // Click on pagination
    $(document).on('click', '.mtt-articles-loop .pagination ul li a', function(e) {

        // Prevent default link behavior
        e.preventDefault();

        // Update page number
        page_number = $(this).attr('data-page');

        // Run ajax request
        getArticles(page_number);

    });

    // Click on category
    if (catSelect) {
        catSelect.addEventListener('change', function() {
            getArticles();
        });
    }


}

function getArticles(page_number) {
    const articlesContainer = $('.mtt-articles-loop__wrapper');
    const searchValue = document.querySelector('#articles-search').value;  
    const cat = document.querySelector('#article-cat').value;

    showLoader();

    // Animate body to top
    $('html, body').animate({
      scrollTop: articlesContainer.offset().top - 180
    }, 500)

    // Set ajax data
    const data = {
        action: 'filter_articles_search',
        s: searchValue,
        page_number: page_number,
        cat: cat
    }
 
    // Ajax call
    $.post(main_theme_objects.ajax_url, data, function(response) {
        if (response !== 0) {
            if (response.result == '') {
                articlesContainer.html('<p class="no-articles"> Der er desværre ingen artikler under disse kriterier. </p>')
            } else {
                articlesContainer.html(response.result);
            }

            // Pagination response
            $('.mtt-articles-loop__pagination').html(response.pagination);
        } 

        removeLoader();
    })
}

function showLoader() {
    // Create loader wrapper
    const loaderWrapper = document.createElement('div')
    loaderWrapper.classList.add('loader')

    // Create spinner
    const loader = document.createElement('div')
    loader.classList.add('spinner')

    // Append wrapper and spinner
    loaderWrapper.appendChild(loader)
    document.querySelector('.mtt-articles-loop__wrapper').appendChild(loaderWrapper)
}

function removeLoader() {
    const loader = document.querySelector('.loader');

    if (loader) {
        loader.parentNode.removeChild(loader);        
    }
}